module.exports = __webpack_public_path__ + "img/img_mobile_txt_activity02.c415ec68.png";